import { useEffect, useState } from "react";
import * as api from "./client";
import type { User } from "./client";

/**
 * Subscribe to the shared "current user" cache in `client.ts`. Returns
 * the latest user (or null when logged out / not yet probed) and
 * re-renders whenever any path updates the cache — login, /api/me,
 * any cheat or item-use mutation that calls `refreshMe`, etc.
 *
 * The hook does NOT issue its own `/api/me` request — `RequireAuth`
 * in `App.tsx` already fires one on every route change, so the cache
 * is usually warm by the time a page mounts. Pages that need to
 * guarantee a fresh probe should still `await api.getMe()` in their
 * own effect; concurrent calls share one in-flight request.
 */
export function useMe(): User | null {
  const [user, setUser] = useState<User | null>(
    api.getCachedMe() as User | null,
  );
  useEffect(() => api.subscribeMe(setUser as (u: unknown) => void), []);
  return user;
}
